import React from 'react';
import { Briefcase } from 'lucide-react';

export default function Experience() {
    return (
        <section id="experience" className="mb-12 px-4 sm:px-6 lg:px-8">
            <h2 className="text-2xl sm:text-3xl font-bold mb-6 pb-2 border-b-2 border-blue-500">
                EXPERIENCE
            </h2>
            <div className="bg-white p-6 rounded-lg shadow-md">
                <div className="flex flex-col sm:flex-row sm:justify-between items-start mb-4">
                    <h3 className="font-bold text-lg sm:text-xl text-blue-800">
                        Teaching Assistant, IIT Hyderabad
                    </h3>
                    <span className="text-gray-600 whitespace-nowrap mt-2 sm:mt-0">
                        Aug&apos;23 – May&apos;25
                    </span>
                </div>
                <p className="mb-2 text-sm sm:text-base">
                    <strong>Department:</strong> Computer Science & Engineering
                </p>
                <p className="mb-4 flex items-center gap-2 text-sm sm:text-base">
                    <Briefcase size={16} className="text-blue-800" />
                    <strong>Role:</strong> Assisted in UG & PG course delivery, evaluation, and mentorship.
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-800 text-sm sm:text-base leading-relaxed">
                    <li>
                        Supported professors in 8 undergraduate and postgraduate courses including:
                        <span className="block pl-4 italic text-gray-600 text-xs sm:text-sm break-words">
                            Introduction to Programming (ID1063), DBMS-I (CS3550), DBMS-II (CS3563), Software Development Fundamentals (CS1023), Advanced Data Structures and Algorithms (CS6013), Linear Optimization (CS5040), Network Security (CS6903), and Fraud Analytics (CS6890)
                        </span>
                    </li>
                    <li>
                        Created assignments, evaluated coursework, invigilated exams, and performed plagiarism checks to maintain academic integrity.
                    </li>
                    <li>
                        Gained hands-on exposure to curriculum planning and mentoring in core CS and cybersecurity topics.
                    </li>
                </ul>
            </div>
        </section>
    );
}
